<!--
Author: TangChen
Date: 2018-10-22
Desc: 现金宝充值，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-currency-charge bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/currencyfund' }">
                    现金宝
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="账户余额：" class="form-text red">
                <div v-cloak class="text-con">
                    {{ $util.fmtNum(fundInfo.all)+'元' }}
                </div>
            </el-form-item>
            <el-form-item label="支付方式：" prop="pay" class="payway-list">
                <el-select v-model="fundInfo.pay" placeholder="请选择支付方式" :class="{'hasVal':bankInfo && bankInfo.label}" v-on:change="bankSel">
                    <el-option-group
                        v-for="(group,index) in bankLists"
                        :key="index"
                        :label="group.label"
                        class="bank-sel"
                    >
                        <el-option
                            v-for="item in group.options"
                            :key="item.moneyaccount"
                            :label="item.label"
                            :value="item.moneyaccount"
                        >
                            <div v-if="!item.bankAdd" class="bank-info">
                                <img :src="$util.getImg(item.bankid)">
                                <span>{{ item.label }}</span>
                                <p v-if="!item.bankAdd">
                                    {{ item.text }}
                                </p>
                            </div>
                            <div v-if="item.bankAdd" class="option-group">
                                {{ item.bankCate }}<el-button
                                    type="blue"
                                    v-on:click.prevent="$router.push({name:'addbank'})"
                                >
                                    {{ item.bankAdd }}
                                </el-button>
                            </div>
                        </el-option>
                    </el-option-group>
                </el-select>
                <div v-if="bankInfo && bankInfo.label" class="el-select-img">
                    <img :src="$util.getImg(bankInfo.bankid)">
                    <span class="k-text-flow">{{ bankInfo.label }}</span>
                </div>
            </el-form-item>
            <el-form-item label="充值金额：" prop="amount" class="redemp-amount">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                    prefix-icon="fa fa-jpy"
                />
                <span class="redemp-btn">充值太麻烦？<span class="like-a" v-on:click.once="currencyPlan">立即开通定期充值</span></span>
                <p class="redemp-prompt">
                    <i class="el-icon-warning" />充值份额可实时转购其他基金，预计<span class="red">{{ $util.fmtDate(limit.cfmdate) }}</span>产生收益
                </p>
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':xjbFundRisk.sign}">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
            </el-form-item>
            <el-form-item>
                <div style="width:50%;">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="time>0"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        立即充值
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <fund-protocol v-model="protocol" :fund="xjbFundRisk" v-on:all-read="buyFund" />
        <verifycode-check :dialog-visible="checkMobile" :mobile="bankInfo.mobile" v-on:verify-in="checkVerifyCode" />
        <result v-if="buySuccess" :active="2" :result="result" v-on:return-page="reset" v-on:return-login="$router.push({name:'traderecord'})" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import verifycodeCheck from "@/components/form/verifycodeCheck.vue";
import fundProtocol from "@/components/form/fundProtocol";
import imgCode from "@/components/layout/imgCode.vue";
export default {
    name: "CurrencyCharge",
    components: {
        result,
        verifycodeCheck,
        fundProtocol,
        imgCode
    },
    mixins: [mixin],
    data () {
        return {
            fundInfo: {
                all: "0.00",
                amount: "",
                pay: "",
                pwd: "",
                protocol: ""
            },
            dialogVisible: false,
            protocol: false,
            isPwdCheck: false,
            checkMobile: false, // 短信鉴权验证码显示开关
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "",
                special: false,
                btnL: {
                    text: "继续充值",
                    event: "return-page"
                },
                btnR: {
                    text: "查看记录",
                    event: "return-login"
                },
                btnGroup: [{
                    tit: "充值成功",
                    text: "充值业务已受理成功",
                    btn: "继续充值",
                    url: "return"
                }, {
                    tit: "实时资产到账",
                    text: "可用于购买基金，费率更低",
                    btn: "现金宝买基金",
                    url: "fund"
                }, {
                    tit: "预计确认时间",
                    text: "预计确认：2018-10-25， 如遇节假日则顺延",
                    btn: "查看交易记录",
                    url: "traderecord"
                }]
            },
            query: null,
            time: 0,
            xjbFundRisk: {},
            btnMsg: "立即充值",
            bankLists: [],
            limit: {},
            fundcode: "", // 现金宝code
            rules: {
                amount: [
                    { required: true, message: "请输入充值金额", trigger: "blur" },
                    { validator: this.amountLimit, trigger: "blur" }
                ],
                pay: [
                    { required: true, message: "请选择支付方式", trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            bankInfo: {},
            xjbCode: "", // 现金宝信息
            cfmdate: ""
        };
    },
    watch: {
        "fundInfo.amount" (val) {
            this.isAmount(val);
        }
    },
    mounted () {
        this.isPwdCheck = this.$cache.getPwdCheck("20,22");
        this.xjbCode = this.$cache.getXjbCode();
        this.getCurrencyRisk();
        this.getXjbMes();
        this.getBank();
    },
    methods: {
        currencyPlan () {
            this.$util.fundRiskCheck(this, { fundcode: this.xjbCode, proto: "plan" }, res => {
                if (res) {
                    const _x = Object.assign({}, res, { way: "59" });
                    sessionStorage.setItem("currencyplan", JSON.stringify(_x));
                    this.$router.push({ name: "currencyplan" });
                }
            });
        },
        reset () {
            this.buySuccess = false;
            this.result.special = false;
            this.bankInfo = {};
            this.$refs.fundInfo.resetFields();
            this.getXjbMes();
            this.getBank();
        },
        // 处理限额
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
            }, 1);
        },
        getVerifyCode(val){
            this.dialogVisible = false;
            if (val) {
                this.fundInfo.imgCodeVal = val;
                this.$util.getSdxProtocol(this.xjbFundRisk,(res)=>{
                    this.xjbFundRisk = res;
                    this.protocol = true;
                });
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if(_this.bankInfo.paytype === "1"){
                        _this.dialogVisible = true;
                    }else{
                        _this.$util.getSdxProtocol(_this.xjbFundRisk,(res)=>{
                            _this.xjbFundRisk = res;
                            _this.protocol = true;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        buyFund(val){
            this.protocol = false;
            if(!val)return;
            const _this = this;
            let data = {
                channelid: _this.bankInfo.value,
                moneyaccount: _this.bankInfo.moneyaccount,
                amount: _this.fundInfo.amount,
                riskwarnflag: _this.xjbFundRisk.riskwarnflag,
                riskmismatchflag: _this.xjbFundRisk.riskmismatchflag,
                highriskwarnflag: _this.xjbFundRisk.highriskwarnflag,
                fundmismatchflag: _this.xjbFundRisk.fundmismatchflag,
                verifycode: this.fundInfo.imgCodeVal,
                tpasswd: _this.$util.enc(_this.fundInfo.pwd)
            };
            _this.$util.request("xjb/deposit/orderpay", data, "POST").then(res => {
                if (!res.data) {
                    _this.resultMes(res);
                }
                _this.cfmdate = res.data[0].cfmdate;
                if (_this.bankInfo.paytype === "1") {
                    _this.checkMobile = true;
                } else if (_this.bankInfo.paytype === "2") {
                    _this.resultMes(res);
                } else if (_this.bankInfo.paytype === "3") {
                    const pageUrl = res.data[0].url;
                    _this.$util.newWinOpen(pageUrl);
                    _this.$util.confirmBankAuth(_this, {}, "xjb/deposit/payresult", function () {
                        let _x = {
                            msg: res.msg,
                            data: [{ cfmdate: _this.cfmdate }]
                        };
                        _this.resultMes(_x);
                    });
                }
            });
        },
        // 获取对应银行卡信息
        bankSel (val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.moneyaccount === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
        },
        // 获取现金宝信息
        getXjbMes () {
            this.$util.request("xjb/query/asset").then(res => {
                if (res.data) {
                    this.fundInfo.all = res.data[0].totalasset;
                }
            });
        },
        // 获取现金宝买基金适当性信息
        getCurrencyRisk () {
            const _this = this;
            this.fundcode = this.$cache.getXjbCode().substr(0, 6);
            if (this.fundcode) {
                this.$util.fundRiskCheck(_this, { fundcode: this.fundcode, proto: "currency" }, function (data) {
                    _this.xjbFundRisk = data;
                });
            }
        },
        getBank () {
            const _this = this;
            // 获取银行卡信息
            this.$util.getBank("xjb/deposit/banklist", res => {
                _this.bankLists = res.bank;
                _this.limit = res.other;
                _this.$set(_this.limit, "text", "充值金额范围为：");
                const _x = _this.bankLists[0].options[1].moneyaccount;
                if (_x) {
                    _this.$set(_this.fundInfo, "pay", _x);
                    _this.bankSel(_x);
                }
                _this.pla = "限额：" + _this.limit.min + "元 ~ " + _this.limit.max + "元";
            });
        },
        resultMes (res) {
            if (res.data) {
                this.result.cla = "register-success";
                this.result.special = true;
                this.result.btnGroup[2].text = "预计确认：" + this.$util.fmtDate(this.cfmdate) + "， 如遇节假日则顺延";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            this.result.msg = "您的充值申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            this.buySuccess = true;
        },
        checkVerifyCode (val) {
            this.checkMobile = false;
            if (!val) return false;
            const _this = this;
            this.$util.request("xjb/deposit/paycheckmsg", { verifycode: val }, "POST").then(res => {
                let _x = {
                    msg: res.msg
                };
                if (res.data) {
                    _x.data = [{ status: "1" }];
                }
                _this.resultMes(_x);
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-currency-charge {
    padding-bottom: 30px;
}
</style>
